module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-4.86d07384.jpg";